<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
             Department of Agri Product Sale and Marketing/ Purchaser
            
          </h2>
        </div>
      </div>

          <div class="columns scrollme" v-if="roleid==6 || roleid==7">
            <div class="column">
              <b-field> 
                  <b-button v-if="ordermaker_emergency==1"
                        class="is-small btn-group-margin"
                        type="is-danger"
                        size="is-small"
                        @click="SwitchOrderService(1)"    
                    >ຮັບອໍເດີ້ໄດ້ທຸກຄົນ
                  </b-button> 
                  <b-button v-else
                        class="is-small btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        @click="SwitchOrderService(2)"    
                    >ຮັບອໍເດີ້ ຕາມສິນຄ້າ ທີ່ມອບໝາຍ
                  </b-button> 
                </b-field>
              <b-field label="ລາຍການສິນຄ້າ">
                
                
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="25%">
                        ຊື່ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="70%">
                        ຜູ້ຮັບຜິດຊອບ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in productPurchaserList"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
  
                      <td> 
                        <b-field>
                          <b-field v-for="item in data.PRODUCT_PURCHASER" :key="item.PRODUCTPURCHASERID"> 
                              
                              <b-button
                                class="is-small btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="removeProductPurchaser(item.PRODUCTPURCHASERID)"    
                            ><span style="font-size:16px">{{ item.PURCHASER }}</span>
                            </b-button> 
                          </b-field> 
                          <b-field v-for="item in data.PURCHASER" :key="item.PURCHASERID">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"  
                              size="is-small"
                              @click="addProductPurchaser(data.PRODUCTID, item.PURCHASERID)"
                              ><span style="font-size:16px">{{ item.PURCHASER  }}</span>
                            </b-button>
                          </b-field> 
                        </b-field>
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,
    productPurchaserList: [],
    ordermaker_emergency: 0,
    

    
  };
  },
  methods: {

    
    SwitchOrderService(type){
      this.$swal({  
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
       if (result.value) {

          var params = {
            type: type,
            username: this.username,    
          };
          
         RestAPI.SwitchOrderService(params)   
           .then(() => {
            
             this.getProductPurchaser();

             this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
    },

    removeProductPurchaser(productpurchaserid){
      this.$swal({  
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
       if (result.value) {

          var params = {
            productpurchaserid: productpurchaserid,
            username: this.username,    
          };
          
         RestAPI.removeProductPurchaser(params)   
           .then(() => {
            
             this.getProductPurchaser();

             this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
    },
    
    addProductPurchaser(productid, purchaserid){
      this.$swal({  
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
       if (result.value) {

          var params = {
            productid: productid,
            purchaserid: purchaserid,
            username: this.username,    
          };

          // console.log("params: "+JSON.stringify(params))  
          
         RestAPI.addProductPurchaser(params)   
           .then(() => {
            
             this.getProductPurchaser();

             this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
    },
    getProductPurchaser(){
      const loadingComponent = this.$loading.open({});  
        RestAPI.getProductPurchaser() 
        .then((res) => {
          this.productPurchaserList =  res.data.product;        
          this.ordermaker_emergency =  res.data.ordermaker_emergency;     
          loadingComponent.close();   
        })
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });

      
    },
   
    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getProductPurchaser();
    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
